import moment from 'moment'

export function getCurrentMonthDayYearDate() {
  const date = new Date()
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  })
}

export function getMonthDayYearDate(timestamp, isEpoch = false) {
  const date = isEpoch ? moment.unix(timestamp) : moment(timestamp)
  return date.format('MMM D, YYYY')
}

export const isDateDisabled = (date, defaultStartDate, defaultEndDate) => {
  // only allow days within 30 days of current date for Notifications and Webhooks events
  return (
    date.getTime() < defaultStartDate.getTime() ||
    date.getTime() > defaultEndDate.getTime()
  )
}

export const rangeLabel = (start, end) => {
  const duration = moment.duration(end.diff(start))
  const hours = Math.round(duration.asHours())

  const numValue = hours
  let label, suffix

  if (numValue === 1) {
    label = hours
    suffix = 'hour'
  } else if (numValue <= 24) {
    label = hours
    suffix = 'hours'
  } else {
    label = Math.round(hours / 24)
    suffix = 'days'
  }

  return { suffix, label }
}
